import angular from 'angular';
import uiRouter from 'angular-ui-router';
import workTeamCardComponent from './workTeamCard.component';

let workTeamCardModule = angular.module('workTeamCard', [
  uiRouter
])

.component('workTeamCard', workTeamCardComponent)

.name;

export default workTeamCardModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/workTeamList/workTeamCard/workTeamCard.js